export const en = {
    Routines: {
        list: {
            heading: "Organization routines",
            description: "Recurring runs your organization publishes to its audience. Each routine invokes one skill.",
            newAutomation: "New routine",
            loading: "Loading routines",
            tryNow: "Try it now",
            edit: "Edit",
            delete: "Delete",
            label: "{{skill}} · {{audience}}",
            skillWithTemplate: "{{skill}} · {{template}}",
            default: "Default",
            rowMenu: "Actions for {{name}}"
        },
        received: {
            heading: "Routines you receive",
            description: "Your organization runs these for you. Turn one off to stop receiving it.",
            empty: "No agent routines are being delivered to you right now."
        },
        mute: {
            turnOff: "Turn off",
            turnBackOn: "Turn back on",
            turnedOff: "Turned off. You no longer receive it.",
            turnedBackOn: "Turned back on. You receive it again."
        },
        organization: {
            turnOff: "Turn off for the organization",
            turnOn: "Turn on for the organization",
            turnedOn: "Turned on for the organization.",
            turnedOff: "Turned off for the organization.",
            confirmTitle: "Turn off for the organization?",
            confirmDescription: "No one in its audience receives it until you turn it back on. People who turned it off for themselves keep that choice.",
            confirm: "Turn off"
        },
        loadError: {
            title: "Couldn't load routines",
            retry: "Try again"
        },
        columns: { automation: "Routine", trigger: "Trigger", skill: "Skill", audience: "Audience", status: "Status", actions: "Actions" },
        firstRoutine: {
            schedule: "Every Monday, 8:00 AM",
            steps: { skill: "Pick a skill", schedule: "Set a schedule", audience: "Reach an audience" },
            benefit: "A routine runs a skill on a schedule for everyone in its audience, so each person gets the result without asking."
        },
        deletedToast: "Routine deleted.",
        delete: {
            title: "Delete {{name}}?",
            description: "Its audience stops receiving it. This can't be undone.",
            confirm: "Delete",
            error: "Couldn't delete the routine. Try again."
        },
        create: {
            created: "Routine created.",
            error: "Couldn't create the routine. Try again."
        },
        form: {
            skill: "Skill",
            template: "Template",
            templateDefault: "Default",
            audience: "Audience",
            cadenceManagedDefault: "Always weekly for the default routine",
            audienceManagedDefault: "Managed for every manager",
            audienceEveryone: "Sent to everyone in the organization",
            audienceUnchangeable: "This audience can't be changed here",
            cadence: "Cadence",
            day: "Send on",
            deliveryNote: "Delivered to each recipient through their notification channel.",
            submit: "Create routine",
            cancel: "Cancel"
        },
        edit: {
            title: "Edit routine",
            submit: "Save changes",
            saved: "Routine updated.",
            error: "Couldn't save the routine. Try again."
        },
        result: {
            title: "{{skill}} preview",
            close: "Close",
            composing: "Workleap Agent is running {{skill}}…",
            failed: "The run failed. Try it again.",
            empty: "Nothing to show yet",
            emptyDescription: "The skill found nothing to report for you right now.",
            opensInNewTab: "opens in a new tab"
        },
        role: { managers: "Managers", executives: "Executives" },
        audienceValue: { everyone: "Everyone" },
        status: { active: "Active", paused: "Paused", off: "Off" },
        cadence: { weekly: "Weekly", biweekly: "Every two weeks", monthly: "Monthly" },
        trigger: { weekly: "Every {{day}}", biweekly: "Every other {{day}}", monthly: "Monthly" },
        day: { monday: "Monday", tuesday: "Tuesday", wednesday: "Wednesday", thursday: "Thursday", friday: "Friday", saturday: "Saturday", sunday: "Sunday" },
        skillName: {
            wai_weekly_brief: "Weekly brief",
            wov_engagement_report: "Pulse report",
            wov_help_me_reply_to_feedback: "Help me reply to feedback",
            wpm_review: "Performance review",
            wai_people_about: "About People",
            draft_a_plan: "Draft a plan",
            wov_summarize_feedback: "Summarize feedback",
            wov_feedback_export: "Export feedback report",
            wov_analyze_engagement: "Analyze engagement",
            wov_export_engagement: "Export engagement report"
        }
    }
};
